import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  defaultLandscape: true,
  defaultVertical: true,
};

export const axisSlice = createSlice({
  name: "axis",
  initialState,
  reducers: {
    updateDefaultLandscape: (state, action) => {
      return {
        ...state,
        defaultLandscape: !state.defaultLandscape,
      };
    },

    updateDefaultVertical: (state, action) => {
      return {
        ...state,
        defaultVertical: !state.defaultVertical,
      };
    },
  },
});

export const { updateDefaultLandscape, updateDefaultVertical } =
  axisSlice.actions;

export default axisSlice.reducer;
